/* eslint-disable react/prop-types */

export const ColumnFilterReadOnly = ( { column } ) => {
	
	const {filterValue, setFilter} = column
	return(
		<div>
		
			<input style={{border:"none"}} readOnly className="form-control border-none input-search bg-dark"
				value={filterValue || ''}  onChange={e => setFilter(e.target.value)} />
		</div>
	)
} 